module.exports = __webpack_public_path__ + "img/index-welcome-image.9b638775.png";